import { connect } from 'react-redux';
import NoteModal from './noteModal';

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {})(NoteModal);
